import React from 'react';
import {
  StatLinkClassProp,
  DataDtm,
} from '../../../utils/externalAnalyticsGM';

interface FailureViewProps {
  onRetry: () => void;
  t: (key: string, fallback?: string) => string;
}

const FailureView: React.FC<FailureViewProps> = ({ onRetry, t }) => {
  return (
    <div className="save-dialog__content-wrapper save-dialog__content-wrapper--form">
      <div
        className="save-dialog__success-message"
        style={{ textAlign: 'center', padding: '40px 0' }}
      >
        <h2 className="save-dialog__title" style={{ color: '#ff4d4f' }}>
          {t('staticTranslations.saveDialog.errorTitle', 'Submission Failed')}
        </h2>
        <p className="save-dialog__privacy-text">
          {t(
            'staticTranslations.saveDialog.errorMessage',
            'We encountered an error, please try again.'
          )}
        </p>
        <div className="save-dialog__footer">
          <button
            className={`save-dialog__submit-button ${StatLinkClassProp.statsubmitbutton}`}
            onClick={onRetry}
            style={{ flex: 1 }}
            data-dtm={DataDtm.Submit}
          >
            {t('staticTranslations.saveDialog.buttonRetry', 'Retry')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FailureView;
